// Registration ownership stays in this tab and never enters forms, URLs or analytics.
const tokens = new Map();
const storageKey = (email) => `registration-capability:${String(email || '').toLowerCase()}`;
export const rememberRegistrationToken = (email, token) => {
  if (!token) return;
  const key = storageKey(email);
  tokens.set(key, token);
  try {
    window.sessionStorage.setItem(key, token);
  } catch {
    /* Keep the in-memory session. */
  }
};
export const registrationTokenFor = (email) => {
  const key = storageKey(email);
  try {
    return tokens.get(key) || window.sessionStorage.getItem(key) || undefined;
  } catch {
    return tokens.get(key);
  }
};
